import PARENT from '../types.js';

const DATASET = `${PARENT}/DATASET`;
// parameters
export const SET_PARAMETERS = `${DATASET}/SET_PARAMETERS`;
const SELECTED_PARAMETERS = `${PARENT}/SELECTED_PARAMETERS`;

export const SET_SELECTED_PARAMETERS = `${SELECTED_PARAMETERS}/SET`;
export const RESET_SELECTED_PARAMETERS = `${SELECTED_PARAMETERS}/RESET`;

export const SET_SELECTED_PARAMETERS_FILTER = `${SELECTED_PARAMETERS}/SET_FILTER`;
export const RESET_SELECTED_PARAMETERS_FILTER = `${SELECTED_PARAMETERS}/RESET_FILTER`;

export const TOGGLE_SELECTED_PARAMETER_VISIBILITY = `${SELECTED_PARAMETERS}/TOGGLE_VISIBILITY`;


// summary
export const SET_SUMMARY = `${DATASET}/SET_SUMMARY`;

export const RESET_DATASET = `${DATASET}/RESET_DATASET`;

export default DATASET;
